// src/libs/i18n/const.ts
export const EN_US = 'en-US';
export const FR_FR = 'fr-FR';
export const ES_ES = 'es-ES';
